import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
import { AuthService } from '../login/auth.service';


@Injectable()
export class StatisticsService {

  private headers: Headers;
  private url = environment.apiUrl;

  constructor(private http: Http, authService: AuthService) {
    this.headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer '+authService.getAuth().token})
  }

  getDashboardStats(params): Promise<Stats> {
    const stats = this.http
      .post(
        this.url+'/stats', 
        {
          ad_ids: params.ad_ids,
          region_ids: params.region_ids,
          dates: params.dates,
          country_ids: params.country_ids,
          timeslot_ids: params.timeslots_ids,
          city_ids: params.city_ids
        }, 
        {headers: this.headers}
      )
      .toPromise()
      .then(res => res.json() as Stats)
      .catch(this.handleError);

      return stats
  }

  getStatsGraphs(params): Promise<GraphStats> {
    const stats = this.http
      .post(
        this.url+'/stats_graphs', 
        {
          ad_ids: params.ad_ids,
          dates: params.dates,
        }, 
        {headers: this.headers}
      )
      .toPromise()
      .then(res => res.json() as GraphStats)
      .catch(this.handleError);

      return stats
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}


export class Stats {
  public ad_spent_gross?: number;
  public ad_spent_net?: number;
  public air_time?: number;
  public number_of_playbacks?: number;
  public views?: number;
  public views_per_minute?: number;
  public cpv_gross?: number;
  public cpv_net?: number;
  public impressions?: number;
  public impressions_per_minute ?: number;
  public cpm_impression_gross?: number;
  public cpm_impression_net?: number;

  public male_0_11?: number;
  public female_0_11?: number;
  public male_12_17?: number;
  public female_12_17?: number;
  public male_18_24?: number;
  public female_18_24?: number;
  public male_25_34?: number;
  public female_25_34?: number;
  public male_35_44?: number;
  public female_35_44?: number;
  public male_45_54?: number;
  public female_45_54?: number;
  public male_55_64?: number;
  public female_55_64?: number;
  public male_65_74?: number;
  public female_65_74?: number;
  public male_75?: number;
  public female_75?: number;

  // TODO: add errors array
}
// TODO: check if data will be sorted by date
export class GraphStats {
  graph_stats:  AdData[];
}

// TODO: check if this can be nullable
export class AdData {
  ad_id: number;
  date: string;
  views: number;
  ad_minutes: number;
  view_per_minute: number;
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/statistics.service.ts